import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { UiModalComponent } from '@components';
import { AssetType, defaultValueFor, } from '@components/ui-value-type/ui-value-type.component';
import { AssetScope, CredentialStoreResourceType, FolderType, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { AssetService, CredentialStoresService, } from '@services';
import UiValidators, { UI_ASSET_DESCRIPTION_MAX_LENGTH, UI_ASSET_NAME_MAX_LENGTH, } from '@validators';
import { BehaviorSubject, forkJoin, Subject, } from 'rxjs';
import { finalize, map, takeUntil, } from 'rxjs/operators';
import { UiRobotValueEditorComponent, UiSingleValueEditorComponent, } from '../../components';
import { generatePayloadFrom } from '../../utils';
var AssetModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AssetModalComponent, _super);
    function AssetModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.className = true;
        _this.credentialStoreChange = new Subject();
        _this.isReadOnly$ = new BehaviorSubject(undefined);
        _this.loadingData$ = new BehaviorSubject(true);
        _this.isValidPerRobot = false;
        _this.valueTypes = [];
        _this.isModernFolder = false;
        _this.loading$ = new BehaviorSubject(false);
        _this._destroyed$ = new Subject();
        _this._assetService = _this._injector.get(AssetService);
        _this._credentialService = _this._injector.get(CredentialStoresService);
        _this._translateService = _this._injector.get(TranslateService);
        _this._appState = _this._injector.get(AppStateFacade);
        return _this;
    }
    Object.defineProperty(AssetModalComponent.prototype, "selectedType", {
        get: function () {
            var _this = this;
            return this.valueTypes.filter(function (valueType) { return valueType.id === _this.context.data.type; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssetModalComponent.prototype, "hasRobots", {
        get: function () {
            return this.robotValueEditor && this.robotValueEditor.robotAssets.values.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    AssetModalComponent.prototype.hasGlobalValue = function () {
        var data = this.context.data;
        return data.scope === AssetScope[AssetScope.Global] || data.value != null;
    };
    AssetModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isModernFolder = this._appState.user.folder.type === FolderType.Modern;
        if (this.context.isNewEntry) {
            this.context.data.type = AssetType.Text;
            this.isDefaultChecked = true;
        }
        else {
            this.isDefaultChecked = this.hasGlobalValue();
        }
        this.context.data.robotValues = this.context.data.robotValues || [];
        this.valueTypes = Object.keys(AssetType)
            .filter(function (key) { return isNaN(Number.parseInt(key, 10)); })
            .map(function (valueType) { return ({
            id: valueType,
            text: _this._translateService.instant("AssetType_" + valueType),
        }); });
        var robotCredentialStore = this.context.data.robotValues &&
            this.context.data.robotValues.length &&
            this.context.data.robotValues[0].credentialStoreId;
        var storedCredentialStore = this.context.data.credentialStoreId || robotCredentialStore;
        var credentialStores$ = this._credentialService.get().pipe(map(function (stores) { return stores.data.filter(function (store) { return store.details; }); }), map(function (stores) { return _this.credentialStoreDropdownEntries = stores.map(function (store) { return ({
            id: store.id,
            text: store.name,
            data: store,
        }); }); }));
        var defaultAssetCredentialStore$ = this._credentialService.getDefaultStore(CredentialStoreResourceType.AssetCredential);
        forkJoin([
            credentialStores$,
            defaultAssetCredentialStore$,
        ]).pipe(finalize(function () { return _this.loadingData$.next(false); })).subscribe(function (_a) {
            var credentialStores = _a[0], defaultCredentialStoreId = _a[1];
            var selectedCredentialStore = credentialStores.filter(function (cs) { return cs.id === (storedCredentialStore || defaultCredentialStoreId); });
            if (!selectedCredentialStore.length) {
                selectedCredentialStore = credentialStores.filter(function (cs) { return cs.id === defaultCredentialStoreId; });
            }
            _this.formGroup.get('credentialStore').setValue(selectedCredentialStore);
        });
        this.formGroup = this._injector.get(FormBuilder).group({
            'name': [
                this.context.data.name,
                Validators.compose([
                    UiValidators.required(),
                    Validators.maxLength(UI_ASSET_NAME_MAX_LENGTH),
                ])
            ],
            'description': [
                this.context.data.description,
                Validators.maxLength(UI_ASSET_DESCRIPTION_MAX_LENGTH),
            ],
            'type': [[this.context.data.type]],
            'credentialStore': [],
        });
        this.formGroup.get('credentialStore').valueChanges
            .pipe(takeUntil(this._destroyed$)).subscribe(function (_a) {
            var value = _a[0];
            var storeDetails = value && value.data && value.data.details;
            _this.isReadOnly$.next(storeDetails ? storeDetails.isReadOnly : false);
            _this.credentialStoreChange.next();
        });
    };
    AssetModalComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
        this.credentialStoreChange.complete();
    };
    AssetModalComponent.prototype.onTypeChange = function (event) {
        this.context.data.type = event.id;
    };
    AssetModalComponent.prototype.onSubmit = function (ev) {
        var _this = this;
        ev.preventDefault();
        this.loading$.next(true);
        if (this.context.isNewEntry) {
            this._assetService
                .add(this._generatePayload())
                .pipe(finalize(function () { return _this.loading$.next(false); }))
                .subscribe(function () {
                _this._dialogRef.close({
                    type: 1 /* Add */,
                });
            });
            this.loading$.next(false);
        }
        else {
            this._assetService
                .update(this.context.data.id, this._generatePayload())
                .pipe(finalize(function () { return _this.loading$.next(false); }))
                .subscribe(function () {
                _this._dialogRef.close({
                    type: 2 /* Update */,
                });
            });
        }
    };
    AssetModalComponent.prototype._generatePayload = function () {
        var model = this.singleValueEditor.formGroup.get('value').value;
        var payload = generatePayloadFrom(this.context.data, this.context.data.type, this.isDefaultChecked ? model : defaultValueFor(this.context.data.type, null, this.isReadOnly$.value), this.isReadOnly$.value);
        payload.name = this.formGroup.get('name').value;
        payload.description = this.formGroup.get('description').value;
        payload.scope = this.isDefaultChecked && !this.hasRobots ?
            AssetScope[AssetScope.Global] : AssetScope[AssetScope.PerRobot];
        var credentialStore = this.formGroup.get('credentialStore').value[0];
        payload.credentialStoreId = payload.type === AssetType.Credential && this.isDefaultChecked
            ? credentialStore.data.id
            : undefined;
        payload.canBeDeleted = this.context.data.canBeDeleted;
        payload.hasDefaultValue = this.isDefaultChecked;
        payload.robotValues = payload.scope === AssetScope[AssetScope.PerRobot] ?
            this.robotValueEditor.robotAssets.values :
            [];
        return payload;
    };
    return AssetModalComponent;
}(UiModalComponent));
export { AssetModalComponent };
